export const mockData = {
  status: "ok",
  totalResults: 67,
  articles: [
    {
      source: { id: null, name: "Liputan6.com" },
      author: "Yuslianson",
      title:
        "Top 3 Tekno: Sony Beli Bungie hingga ByteDance Uji Coba Metaverse - Liputan6.com",
      description:
        "Artikel tentang dibelinya studio game Bungie senilai Rp 51,7 triliun oleh Sony ini, mencuri perhatian pembaca kanal Tekno Liputan6.com, Senin (31/1/2022).",
      url: "https://www.liputan6.com/tekno/read/4875559/top-3-tekno-sony-beli-bungie-hingga-bytedance-uji-coba-metaverse",
      urlToImage:
        "https://cdn1-production-images-kly.akamaized.net/zj9ERzL7CxoZHZvnatjI6FtUDaA=/1200x675/smart/filters:quality(75):strip_icc():format(jpeg)/kly-media-production/medias/2375300/original/034182800_1538728175-PlayStation-Logo-796x416.jpg",
      publishedAt: "2022-02-02T04:30:57Z",
      content:
        "Liputan6.com, Jakarta - Sony baru saja mengumumkan telah membeli studio game dibalik kesuksesan Destiny 2 dan kreator asli gim Halo, yakni Bungie.\r\nArtikel tentang dibelinya studio game Bungie senila… [+817 chars]",
    },
    {
      source: { id: null, name: "Pikiran-rakyat.com" },
      author: "Umam Ismail",
      title:
        "MANTAP! Ini Spesifikasi Lengkap Xiaomi Mi 10T 5G, HP Gaming Murah Meriah dengan RAM 8GB - Mantra Sukabumi - Mantra Sukabumi",
      description:
        "Spesifikasi dan estimasi harga terbaik dari HP Xiaomi Mi 10T 5G yang dibekali dengan RAM 8GB sangat cocok untuk gaming",
      url: "https://mantrasukabumi.pikiran-rakyat.com/teknologi/pr-203628345/mantap-ini-spesifikasi-lengkap-xiaomi-mi-10t-5g-hp-gaming-murah-meriah-dengan-ram-8gb",
      urlToImage:
        "https://assets.pikiran-rakyat.com/crop/156x189:1248x727/750x500/photo/2021/09/08/1905186830.jpg",
      publishedAt: "2022-02-02T03:50:00Z",
      content: null,
    },
    {
      source: { id: null, name: "Antaranews.com" },
      author: "Natisha Andarningtyas",
      title: "iPhone SE dan iPad Air baru dites di India - ANTARA",
      description:
        "Apple dikabarkan sedang menguji coba iPhone SE dan iPad Air generasi terbaru di India, menyusul rumor peluncuran gawai baru pada Maret atau April.\r\n\r\nPhone ...",
      url: "https://www.antaranews.com/berita/2678597/iphone-se-dan-ipad-air-baru-dites-di-india",
      urlToImage:
        "https://img.antaranews.com/cache/800x533/2022/01/18/apple-ipad-air-4.jpg",
      publishedAt: "2022-02-02T03:10:05Z",
      content:
        "Jakarta (ANTARA) - Apple dikabarkan sedang menguji coba iPhone SE dan iPad Air generasi terbaru di India, menyusul rumor peluncuran gawai baru pada Maret atau April.Phone Arena dan 91 Mobiles, dikuti… [+1162 chars]",
    },
    {
      source: { id: null, name: "Cnbcindonesia.com" },
      author: "Novina Putri Bestari",
      title:
        "Cek! Ini Cara Melihat Siapa yang Menyadap Whatsapp Kita - CNBC Indonesia",
      description:
        "Pengguna WhatsApp yang banyak membuat aplikasi ini jadi incaran pembajakan oleh para hacker jahat. Begini cara mengetahuinya.",
      url: "https://www.cnbcindonesia.com/tech/20220202080432-37-312160/cek-ini-cara-melihat-siapa-yang-menyadap-whatsapp-kita",
      urlToImage:
        "https://awsimages.detik.net.id/visual/2018/07/20/8e3afbea-716b-40bc-bb93-ffc9179e6099_169.jpeg?w=650",
      publishedAt: "2022-02-02T03:10:00Z",
      content:
        "Jakarta, CNBC Indonesia - WhatsApp merupakan salah satu aplikasi pesan instan yang paling banyak digunakan. Di satu sisi, juga semakin banyak pihak yang tertarik melakukan kejahatan seperti penyadapa… [+1463 chars]",
    },
    {
      source: { id: null, name: "Pikiran-rakyat.com" },
      author: "Inra Cahyadi",
      title:
        "Harga dan Spesifikasi Xiaomi Redmi 9, HP Gaming dengan Harga Murah - Mantra Sukabumi - Mantra Sukabumi",
      description:
        "Estimasi harga dan spesifikasi terbaik dari HP Xiaomi Redmi 9 yang dibekali RAM besar untuk main gaming",
      url: "https://mantrasukabumi.pikiran-rakyat.com/teknologi/pr-203626603/harga-dan-spesifikasi-xiaomi-redmi-9-hp-gaming-dengan-harga-murah",
      urlToImage:
        "https://assets.pikiran-rakyat.com/crop/0x0:0x0/750x500/photo/2022/01/18/1770608839.png",
      publishedAt: "2022-02-02T02:40:00Z",
      content: null,
    },
    {
      source: { id: null, name: "Pikiran-rakyat.com" },
      author: "Inra Cahyadi",
      title:
        "Review Spesifikasi dan Harga Samsung Galaxy A32, HP Andalan Traveller dan Floger - Mantra Sukabumi - Pikiran Rakyat",
      description:
        "Review spesifikasi dan estimasi harga terbaik dari HP Samsung Galaxy A32 yang menjadi andalan bagi traveller dan floger",
      url: "https://mantrasukabumi.pikiran-rakyat.com/teknologi/pr-203626088/review-spesifikasi-dan-harga-samsung-galaxy-a32-hp-andalan-traveller-dan-floger",
      urlToImage:
        "https://assets.pikiran-rakyat.com/crop/0x101:1440x915/750x500/photo/2021/09/08/3184939131.jpg",
      publishedAt: "2022-02-02T02:35:00Z",
      content: null,
    },
    {
      source: { id: null, name: "Liputan6.com" },
      author: "Yuslianson",
      title:
        "Samsung Galaxy Tab S8 Kantongi Sertifikasi Kemkominfo, Siap Hadir di Indonesia - Liputan6.com",
      description:
        "Samsung Galaxy Tab S8 series sudah lolos TKDN dan mengantongi sertifikasi dari Kemkominfo.",
      url: "https://www.liputan6.com/tekno/read/4875540/samsung-galaxy-tab-s8-kantongi-sertifikasi-kemkominfo-siap-hadir-di-indonesia",
      urlToImage:
        "https://cdn0-production-images-kly.akamaized.net/qQGn6EEoQpbhm2glZODH1CG1G34=/1200x675/smart/filters:quality(75):strip_icc():format(jpeg)/kly-media-production/medias/3612431/original/007805400_1635158350-galaxy-tab-s8-ultra.jpg",
      publishedAt: "2022-02-02T02:30:50Z",
      content:
        "Liputan6.com, Jakarta - Tablet Samsung Galaxy Tab S8 series telah mengantongi sertifikat Tingkat Kandungan Dalam Negeri (TKDN) dari Kementerian Perindustrian.\r\nInformasi ini diketahui dari laman web … [+1219 chars]",
    },
    {
      source: { id: null, name: "Kompas.com" },
      author: "Wahyunanda Kusuma Pertiwi",
      title:
        "Review Samsung Galaxy S21 FE, Flagship yang Datang Terlambat - Kompas.com - Tekno Kompas.com",
      description:
        "Sekitar hampir satu bulan menggunakan Galaxy S21 FE sebagai perangkat utama, kami menemukan anomali yang cukup mengganggu penggunaan.  Halaman all",
      url: "https://tekno.kompas.com/read/2022/02/02/08450047/review-samsung-galaxy-s21-fe-flagship-yang-datang-terlambat",
      urlToImage:
        "https://asset.kompas.com/crops/teKbFxzbFthssADcNb8HRATOxKI=/473x602:5726x4104/780x390/filters:watermark(data/photo/2020/03/10/5e6775b82d394.png,0,-0,1)/data/photo/2022/01/04/61d3ca22a0713.jpg",
      publishedAt: "2022-02-02T01:45:00Z",
      content: null,
    },
    {
      source: { id: null, name: "Genpi.co" },
      author: "agus",
      title: "Download Minecraft 1.18 Gratis di Sini, Cek Yuk - GenPI.co",
      description:
        "Coba deh cek link yang ada di sini. Semua bisa disimak dengan link resmi. Download Minecraft 1.18 bisa...",
      url: "https://www.genpi.co/teknow/163766/download-minecraft-118-gratis-di-sini-cek-yuk",
      urlToImage:
        "https://images.genpi.co/uploads/arsip/normal/2022/01/11/pecinta-game-minecraft-wajib-simak-ini-download-game-minecr-muah.jpg",
      publishedAt: "2022-02-02T01:30:38Z",
      content:
        "GenPI.co - Download Minecraft 1.18 bisa gratis. Coba deh cek link yang ada di sini. Semua bisa disimak dengan link resmi.\r\nSeperti diketahui, bahwa Minecraft merupakan permainan Sandbox, dibuat oleh … [+739 chars]",
    },
    {
      source: { id: null, name: "Indotelko.com" },
      author: "https://www.facebook.com/IndoTelko",
      title: "Angkasa Pura II siapkan airport metaverse - IndoTelko",
      description:
        "Program Airport Metaverse yang dicanangkan AP II ini ke depannya juga akan didorong untuk melibatkan berbagai stakeholder antara lain maskapai dan mitra usaha komersial di bandara.",
      url: "https://www.indotelko.com/read/1643741263/angkasa-pura-ii-siapkan-airport-metaverse",
      urlToImage:
        "https://www.indotelko.com/images/media/202202/ori/WhatsApp Image 2022-02-01 at 23.02.10.jpeg",
      publishedAt: "2022-02-02T01:30:00Z",
      content:
        "JAKARTA (IndoTelko) -- PT Angkasa Pura II, pengelola 20 bandara di Indonesia, memasuki babak baru dalam menjalankan transformasi digital yang telah dimulai sejak 2016. \r\nAP II saat ini telah menerapk… [+4545 chars]",
    },
    {
      source: { id: null, name: "Kontan.co.id" },
      author: "Prihastomo Wahyu Widodo",
      title:
        "Spesifikasi & Harga HP Vivo Y75 5G: Kamera 50MP, RAM Sampai 12GB, Hanya Rp 3,9 Juta - Kontan",
      description:
        "Harga HP Vivo Y75 5G dibanderol hanya Rp 3.999.000 saja, cukup terjangkau jika melihat sederet spesifikasi yang dibawanya.",
      url: "https://lifestyle.kontan.co.id/news/spesifikasi-harga-hp-vivo-y75-5g-kamera-50mp-ram-sampai-12gb-hanya-rp-39-juta",
      urlToImage:
        "https://foto.kontan.co.id/3k64oJ5H5TkauDv_Wi-_1tkD_pg=/smart/2022/02/02/154151908p.jpg",
      publishedAt: "2022-02-02T00:50:05Z",
      content:
        "KONTAN.CO.ID - JAKARTA. Untuk Anda yang sudah tidak sabar ingin membelinya, spesifikasi dan harga HP Vivo Y75 5G ini jelas wajib disimak. Produk kelas menengah baru dari Vivo ini tampil menarik denga… [+3089 chars]",
    },
    {
      source: { id: null, name: "Pikiran-rakyat.com" },
      author: "Rismawan",
      title:
        "Unduh Lagu Buih Jadi Permadani MP3 Cover By Zinidin Zidan Pakai SSYoutube dan Y2mate Gratis - Purwakarta Talk - Pikiran Rakyat",
      description:
        "Pakai Y2mate dan SSYouTube bisa unduh lagu buih jadi permadani dan lagu aku bukan jodohnya.  unduh lagu buih jadi permadani Zinidin Zidan",
      url: "https://purwakarta.pikiran-rakyat.com/entertainment/pr-553626890/unduh-lagu-buih-jadi-permadani-mp3-cover-by-zinidin-zidan-pakai-ssyoutube-dan-y2mate-gratis",
      urlToImage:
        "https://assets.pikiran-rakyat.com/crop/0x0:0x0/750x500/photo/2022/01/10/600998014.jpg",
      publishedAt: "2022-02-02T00:41:50Z",
      content: null,
    },
    {
      source: { id: null, name: "Grid.id" },
      author: null,
      title:
        "Meta Kenalkan 3D Avatar di Instagram, Facebook, dan Messenger - MakeMac",
      description:
        "Baru-baru ini, Meta memperkenalkan 3D Avatar yang dapat digunakan di Instagram, Facebook, dan Messenger. Simak selengkapnya!",
      url: "https://makemac.grid.id/read/213122829/meta-kenalkan-3d-avatar-di-instagram-facebook-dan-messenger",
      urlToImage:
        "https://asset-a.grid.id/crop/0x0:0x0/700x465/photo/2022/02/01/fbjpg-20220201040207.jpg",
      publishedAt: "2022-02-01T23:46:00Z",
      content:
        "Meta secara bertahap mulai meluncurkan fitur-fitur menarik untuk dihadirkan di metaverse.\r\nBaru-baru ini, Meta memperkenalkan 3D Avatar di Instagram, Facebook, dan Messenger.\r\n3D Avatar merupakan seb… [+1018 chars]",
    },
    {
      source: { id: null, name: "Kontan.co.id" },
      author: "Prihastomo Wahyu Widodo",
      title:
        "Seri Termurah & Terpopuler, Berikut Daftar Harga HP Vivo Y Series per Februari 2022 - Kontan",
      description:
        "Di awal tahun 2022 ini, beberapa model baru seperti Vivo Y21T dan Vivo Y75 5G sudah resmi masuk ke dalam daftar harga HP Vivo Y series.",
      url: "https://lifestyle.kontan.co.id/news/seri-termurah-terpopuler-berikut-daftar-harga-hp-vivo-y-series-per-februari-2022",
      urlToImage:
        "https://foto.kontan.co.id/Cm3e_9yF-hKXuphs3CXEhXQpFtE=/smart/2022/01/31/1048910918p.jpg",
      publishedAt: "2022-02-01T23:44:50Z",
      content:
        "KONTAN.CO.ID - JAKARTA. Dikenal sebagai seri termurah dari Vivo, daftar harga HP Vivo Y Series memang berisi produk murah dengan harga mulai dari Rp 1 jutaan saja. \r\nSemua produk yang ada dalam dalam… [+3743 chars]",
    },
    {
      source: { id: null, name: "Cnnindonesia.com" },
      author: "CNN Indonesia",
      title:
        "Respons Apple soal Kontroversi Emoji 'Pregnant Man' - CNN Indonesia",
      description:
        "Emoji terbaru Apple terbaru pada versi beta iOS 15.4 menuai kritik lantaran menampilkan emoji pregnant man atau pria hamil.",
      url: "https://www.cnnindonesia.com/teknologi/20220131151127-185-753414/respons-apple-soal-kontroversi-emoji-pregnant-man",
      urlToImage:
        "https://akcdn.detik.net.id/visual/2021/09/24/iphone-13-mulai-dijual-di-beijing-4_169.jpeg?w=650",
      publishedAt: "2022-02-01T23:41:17Z",
      content:
        "Jakarta, CNN Indonesia -- Emoji terbaru Apple terbaru pada versi beta iOS 15.4 menuai kritik lantaran menampilkan emoji pria hamil. Berikut tanggapan emojipedia Apple soal kontroversi emoji pregnant … [+1784 chars]",
    },
    {
      source: { id: null, name: "Selular.id" },
      author: "Khoirunnisa",
      title: "IDC: Pasar Smartphone Global 2021 Tumbuh, Q4 Lesu - Selular.ID",
      description:
        "Selular.ID - IDC memposting laporan kuartal keempat untuk pasar smartphone global, yang menggenapkan keseluruhan 2021, juga merangkum kinerjanya untuk setahun penuh. Menurut data, pasar smartphone secara keseluruhan mengalami peningkatan 5,7% dalam pengiriman…",
      url: "https://selular.id/2022/02/idc-pasar-smartphone-global-2021-tumbuh-q4-lesu/",
      urlToImage:
        "https://selular.id/wp-content/uploads/2018/05/Smartphone-User.jpg",
      publishedAt: "2022-02-01T23:00:24Z",
      content:
        "Selular.ID – IDC memposting laporan kuartal keempat untuk pasar smartphone global, yang menggenapkan keseluruhan 2021, juga merangkum kinerjanya untuk setahun penuh.\r\nMenurut data, pasar smartphone s… [+1426 chars]",
    },
    {
      source: { id: null, name: "Pikiran-rakyat.com" },
      author: "Muh Romli",
      title:
        "INI CARA GANTI Background Foto dengan Remove.bg Simpel dan Mudah - Priangan Timur News - PrianganTimur News",
      description:
        "Mengubah background merupakan hal wajar namun repot jika harus ke tukang. Ini cara mengubah background foto  dengan menggunakan Remove.bg",
      url: "https://priangantimurnews.pikiran-rakyat.com/teknologi/pr-1223626036/ini-cara-ganti-background-foto-dengan-removebg-simpel-dan-mudah",
      urlToImage:
        "https://assets.pikiran-rakyat.com/crop/0x0:0x0/750x500/photo/2021/11/26/2631585694.jpg",
      publishedAt: "2022-02-01T22:16:57Z",
      content: null,
    },
    {
      source: { id: null, name: "Sindonews.com" },
      author: "Tangguh Yudha",
      title:
        "Distribusi Samsung Galaxy S22 Series Disebut Bakal Molor Lagi - SINDOnews.com",
      description:
        "Seorang analis gadget kenamaan, Jon Prosser menyebut distribusi Samsung Galaxy S22 Series dikabarkan bakal tertunda lagi. Seorang analis gadget kenamaan, Jon Prosser...",
      url: "https://tekno.sindonews.com/read/673915/122/distribusi-samsung-galaxy-s22-series-disebut-bakal-molor-lagi-1643727741",
      urlToImage:
        "https://pict-c.sindonews.net/dyn/850/pena/news/2022/02/01/122/673915/distribusi-samsung-galaxy-s22-series-disebut-bakal-molor-lagi-alx.jpg",
      publishedAt: "2022-02-01T16:54:49Z",
      content:
        "SEOUL - Seorang analis gadget kenamaan, Jon Prosser menyebut distribusi Samsung Galaxy S22 Series dikabarkan bakal tertunda lagi. Seperti dilansir dari Gizmochina, Selasa (1/2/2022), Jon menyebut pen… [+1670 chars]",
    },
    {
      source: { id: null, name: "Sindonews.com" },
      author: "Danang Arradian",
      title:
        "Sama-Sama Tahan Banting, Ini Beda Samsung Galaxy XCover 5 dan Galaxy Tab Active3 - SINDOnews",
      description:
        "Samsung Indonesia mengenalkan ponsel Galaxy XCover 5 dan tablet Samsung Galaxy Tab Active3 yang sama-sama tahan banting untuk pekerja profesional di lapangan. Tapi,...",
      url: "https://tekno.sindonews.com/read/673835/122/sama-sama-tahan-banting-ini-beda-samsung-galaxy-xcover-5-dan-galaxy-tab-active3-1643724167",
      urlToImage:
        "https://pict-c.sindonews.net/dyn/850/pena/news/2022/02/01/122/673835/samasama-tahan-banting-ini-beda-samsung-galaxy-xcover-5-dan-galaxy-tab-active3-zoc.jpg",
      publishedAt: "2022-02-01T16:20:02Z",
      content:
        "JAKARTA - Samsung Indonesia mengenalkan ponsel Galaxy XCover 5 dan tablet Samsung Galaxy Tab Active3 yang sama-sama tahan banting untuk pekerja profesional di lapangan. Tapi, apa perbedaannya? Galaxy… [+1486 chars]",
    },
    {
      source: { id: null, name: "Tribunnews.com" },
      author: "Titik Wahyuningsih",
      title:
        "Rekomendasi HP Rp 1 Jutaan dengan Kapasitas Baterai Jumbo: Galaxy A03s dan Redmi 10 - Tribun Kaltara",
      description:
        "Berikut ini rekomendasi HP 1 jutaan terbaik di pasaran yakni Xiaomi Redmi 10 dan Samsung Galaxy A03s disertai spesifikasi dan harga terbarunya.",
      url: "https://kaltara.tribunnews.com/2022/02/01/rekomendasi-hp-rp-1-jutaan-dengan-kapasitas-baterai-jumbo-galaxy-a03s-dan-redmi-10",
      urlToImage:
        "https://cdn-2.tstatic.net/kaltara/foto/bank/images/galaxy-a03s-baru.jpg",
      publishedAt: "2022-02-01T15:28:38Z",
      content:
        "TRIBUNKALTARA.COM - Berikut ini rekomendasi HP 1 jutaan terbaik di pasaran yakni Xiaomi Redmi 10 dan Samsung Galaxy A03s disertai spesifikasi dan harga terbaru per Februari 2022.\r\nPonsel entry level … [+940 chars]",
    },
  ],
};
